/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Failed_ProfileInputs */

const en_us2_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped while saving your personal details.`)
};

const pt_br2_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao salvar seus dados pessoais.`)
};

const es_419_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detuvo al guardar tus datos personales.`)
};

const pt_pt2_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao guardar os teus dados pessoais.`)
};

const fr_fr2_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompu pendant l'enregistrement de tes informations personnelles.`)
};

const de_de2_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Speichern deiner persönlichen Daten ist es hängen geblieben.`)
};

const it_it2_onboarding_failed_profile = /** @type {(inputs: Onboarding_Failed_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è interrotto mentre salvava i tuoi dati personali.`)
};

/**
* | output |
* | --- |
* | "It stopped while saving your personal details." |
*
* @param {Onboarding_Failed_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_failed_profile = /** @type {((inputs?: Onboarding_Failed_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Failed_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_failed_profile(inputs)
	if (locale === "es-419") return es_419_onboarding_failed_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_failed_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_failed_profile(inputs)
	if (locale === "de-DE") return de_de2_onboarding_failed_profile(inputs)
	if (locale === "it-IT") return it_it2_onboarding_failed_profile(inputs)
	return en_us2_onboarding_failed_profile(inputs)
});
export { onboarding_failed_profile as "onboarding.failed_profile" }